import { useSelector } from 'react-redux';

import { isEqual } from 'lodash-es';

import { getStatistics, getTotalCount } from './utils';

/**
 * @param { Array<{ code: string, deposit: object, withdraw: object, exposure: object, risk: object }> } data
 * @param { string } type
 * @returns { { display: { total: number, exposure: number, risk: number, account: number, currency: string }, original: { total: number, exposure: number, risk: number, account: number, currency: string }, count: number } }
 */
export function useTranslationData(data, type) {
	let next = data;

	if (type) {
		next = data.filter((value) => value.code === type);
	}

	const accounts = useSelector(
		(store) =>
			(store?.accounts?.bankAccounts ?? []).reduce((acc, account) => {
				const currency = account?.sums?.original?.currency;

				const total = {
					original: account?.sums?.original?.total ?? 0,
					display: account?.sums?.display?.total ?? 0,
				};

				return {
					...acc,
					[currency]: {
						original:
							(acc?.[currency]?.original ?? 0) + total.original,
						display:
							(acc?.[currency]?.display ?? 0) + total.display,
					},
				};
			}, {}),
		isEqual,
	);

	return next.reduce(
		(acc, value) => ({
			...acc,
			display: getStatistics(
				acc.display,
				value,
				'display',
				accounts?.[value.code]?.display,
			),
			original: getStatistics(
				acc.original,
				value,
				'original',
				accounts?.[value.code]?.original,
			),
			count: acc.count + getTotalCount(value),
		}),
		{
			original: {
				total: 0,
				exposure: 0,
				risk: 0,
				account: 0,
				currency: null,
			},
			display: {
				total: 0,
				exposure: 0,
				risk: 0,
				account: 0,
				currency: null,
			},
			count: 0,
		},
	);
}
